import { useState, useEffect, useRef, useCallback } from 'react';

const useApiQuery = (query, deps = [], predicate = () => true) => {
  const queryRef = useRef(query);
  queryRef.current = query;

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const [reloadFlag, setReloadFlag] = useState({});

  const reload = useCallback(() => setReloadFlag({}), []);

  useEffect(() => {
    let isMounted = true;
    async function fetchData() {
      try {
        setLoading(true);
        if (predicate()) {
          const data = await queryRef.current();
          if (isMounted) {
            setData(data);
          }
        }
      } catch (e) {
        if (isMounted) {
          setError(e);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    fetchData();
    return () => (isMounted = false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadFlag, ...deps]);

  return {
    data,
    loading,
    error,
    reload
  };
};

export default useApiQuery;
